import { render, staticRenderFns } from "./DownloadDocument.vue?vue&type=template&id=1af5f6f2"
import script from "./DownloadDocument.vue?vue&type=script&lang=js"
export * from "./DownloadDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports